<template>
  <div>
    <div class="m15 container">
      <div class="container m15">
        <!-- 面包屑 -->
        <div class="integralBreadcrumb">
          <div class="integralBreadcrumb-item">
            <router-link :to="{ name: 'basicInfo' }"> 个人中心 </router-link>
          </div>
          <div class="el-icon-arrow-right jt"></div>
          <div>浏览历史</div>
        </div>
      </div>
      <div style="margin-top: 20px" v-if="showGoodlist.length">
        <goods-list :goodsList="showGoodlist"></goods-list>
      </div>
      <div v-else style="text-align: center; margin-top: 15px">
        <el-empty :image="NoGoodImg"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsList from "./goodList";
import NoGoodImg from "@/assets/img/good/noGood.png";
export default {
  name: "browseHistory",
  data() {
    return {
      NoGoodImg,
      // choosedIndex: -1,
      showGoodlist: [],
      page: 1,
      limit: 20,
      // count: 0,
      // 最多拿100条也就是5页
      maxPage: 5,
      loading: false,
      isEnd: false,
    };
  },
  computed: {
    choosedId() {
      return this.$route.query.id;
    },
  },
  watch: {},
  methods: {
    getList() {
      if (this.loading || this.isEnd) {
        return;
      }
      this.loading = true;
      this.$http
        .get(
          `/front/oms/crop-site/browse-history/list?limit=${
            this.limit
          }&page=${this.page}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            let list = [];
            if (res.data && res.data.records) {
              list = res.data.records || [];
            }
            // 数量少于limit，说明没有更多数据了
            // 不超过5页
            if (list.length < this.limit || this.page >= this.maxPage) {
              this.isEnd = true;
            }

            this.showGoodlist.push(...list);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getList();
    var _this = this;
    window.onscroll = function () {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 滚动条到底部的条件
      if (
        scrollHeight - scrollTop - windowHeight < 500 &&
        !_this.loading
      ) {
        // 写后台加载数据的函数
        // console.log(scrollHeight - scrollTop - windowHeight);
        _this.page = _this.page + 1;
        _this.getList();
      }
    };
  },
  mounted() {},
  components: {
    GoodsList,
  },
  // store
};
</script>

<style scoped>
.item-class-spandx {
  background-color: rgb(255, 255, 255);
  padding: 4px 0px 4px 10px;
  border: 1px solid rgb(29, 101, 168);
  color: rgb(29, 101, 168);
  /* margin-top: 1px; */
  font-size: 12px;
}
.iconstyle {
  text-align: center;
  width: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #1d65a8;
  color: #fff;
  font-size: 12px;
}
/*筛选*/
.item-class-show {
  margin: 15px auto;
  width: 100%;
  background: #ffffff;
}
.item-class-group {
  margin-top: 1px;
}
.item-class-name {
  text-align: right;
  padding-right: 15px;
  /*padding-left: 15px;*/
  line-height: 36px;
  /* color: #666; */
  font-weight: bold;
  background-color: #fff;
}
.item-class-name:first-child {
  line-height: 36px;
}
.item-class-select {
  overflow: hidden;
  /* width: 100%; */
  /* height: 36px; */
}
.item-class-select div {
  /* width: 85px; */
  height: 24px;
  text-align: center;
  color: #005aa0;
  /* line-height: 36px; */
  cursor: pointer;
  float: left;
  /* margin-top: 2px; */
}
.item-class-select div span {
  display: block;
  width: 134px;
  padding: 0px;
  border: 0px;
  /* border-radius: 100px; */
  text-align: center;
  color: #333333;
  cursor: pointer;
  /*line-height: 36px;*/
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 0px;
}
.actions {
  margin: 0 auto;
  line-height: 36px;
  align-items: center;
  font-weight: bold;
}
.actions span:hover {
  cursor: pointer;
}
.m15 {
  margin-top: 15px;
  margin-bottom: 15px;
}
.goods-box {
  display: block;
  width: 100%;
}
.goods-box:after {
  content: "";
  display: block;
  clear: both;
}
/* ---------------商品栏开始------------------- */
.ssimg {
  width: 100%;
  height: 100%;
}
.goods-show-info {
  width: 290px;
  margin-right: 10px;
  margin-top: 10px;
  float: left;
  background: #fff;
  height: 300px;
}
.goods-show-infor {
  margin-right: 0px !important;
}
.goods-show-img {
  cursor: pointer;
  width: 100%;
  text-align: center;
  height: 217px;
}
.goods-show-price {
  margin-top: 6px;
}
.goods-show-detail {
  font-size: 12px;
  margin: 0px 0px;
  padding: 10px;
  height: 80px;
  line-height: 30px;
  border-top: 1px #eee solid;
}
.tags {
  color: #005aa0;
}
.goods-show-num {
  font-size: 12px;
  margin-bottom: 6px;
  color: #009688;
}
.goods-show-num span {
  color: #005aa0;
  font-weight: bold;
}
.goods-show-seller {
  font-size: 12px;
  color: #e4393c;
}
.goods-page {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
/* ---------------商品栏结束------------------- */
/*面包屑*/
.ivu-breadcrumb {
  color: #999;
  font-size: 12px;
}
.ivu-breadcrumb-item-separator {
  margin: 0 3px;
  color: #dcdee2;
}

.item_label {
  float: left;
  margin: 0 0 0 15px;
  font-size: 20px;
  line-height: 50px;
  width: 25%;
}
.item_filter {
  float: right;
  line-height: 50px;
  margin: 0 5px;
  max-width: 70%;
}
.item_filter .item {
  float: left;
  cursor: pointer;
  line-height: 50px;
  margin: 0 5px;
}
.item_filter .item:hover {
  color: #409eff;
  text-decoration: underline;
}
.productHref {
  cursor: pointer;
  color: #333;
}
/* 面包屑最后一个取消销售 */
.integralBreadcrumb div:nth-last-child(1) {
  cursor: auto;
}
</style>
